import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-help-guide',
    templateUrl: './help-guide.component.html',
    styleUrls: ['./help-guide.component.css'],
    standalone: false
})
export class HelpGuideComponent implements OnInit {

  // website name and link type
  @Input() website: string = "";
  @Input() linkType: string = "";

  constructor() {

  }

  ngOnInit(): void {

  }

}
